import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import PracticeAreas from "@/pages/PracticeAreas";
import EstatePlanning from "@/pages/EstatePlanning";
import ElderLaw from "@/pages/ElderLaw";
import RealEstate from "@/pages/RealEstate";
import BusinessLaw from "@/pages/BusinessLaw";
import About from "@/pages/About";
import OurValues from "@/pages/OurValues";
import People from "@/pages/People";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";
import LegalLinks from "@/pages/LegalLinks";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import News from "@/pages/News";
import NotFound from "@/pages/NotFound";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLayout from "@/components/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminList from "@/pages/admin/AdminList";
import AdminEditor from "@/pages/admin/AdminEditor";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        {/* Public site */}
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/practice-areas" element={<PracticeAreas />} />
                            <Route path="/estate-planning" element={<EstatePlanning />} />
                            <Route path="/elder-law" element={<ElderLaw />} />
                            <Route path="/real-estate-law" element={<RealEstate />} />
                            <Route path="/business-law" element={<BusinessLaw />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/values" element={<OurValues />} />
                            <Route path="/people" element={<People />} />
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/blog/:slug" element={<BlogPost />} />
                            <Route path="/news" element={<News />} />
                            <Route path="/careers" element={<Careers />} />
                            <Route path="/legal-links" element={<LegalLinks />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="*" element={<NotFound />} />
                        </Route>

                        {/* Admin */}
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route element={<ProtectedRoute />}>
                            <Route element={<AdminLayout />}>
                                <Route path="/admin" element={<AdminList />} />
                                <Route path="/admin/new" element={<AdminEditor />} />
                                <Route path="/admin/edit/:id" element={<AdminEditor />} />
                            </Route>
                        </Route>
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
            <Toaster position="top-center" richColors closeButton />
        </div>
    );
}

export default App;
